import { OperatorConfig } from "@ogs-gmbh/rsql";

export const RSQL_OPERATORS: OperatorConfig = {
  LIKE: "=lk="
};
